// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"cf995aec","967":"2e0d7fd6"}[chunkId] + ".chunk.js";
};